<p>detail-mark-auto works!</p>
